import React, { Component, Fragment } from 'react'
import * as R from 'ramda'
import Input from 'components/fulcrum/input/Input'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  IconButton
} from 'react-toolbox'
import CSSModules from 'react-css-modules'
import styles from './styles.scss'
import { COUNT, DETAILS, TYPE } from './constant'

class ProductStorage extends Component {
  handleChange = (index, type, val) => {
    if (type === COUNT) val = Math.abs(parseInt(val))
    this.props.onChange(index, type, val)
  };

  handleRemove(index) {
    return () => this.props.onRemove(index)
  }

  getTableHead = (tableHeadContent) =>  (
    <TableHead>
        {R.map((key) => tableHeadContent[key], R.keys(tableHeadContent))}
    </TableHead>
  )

  renderRows = () => {
    const { values, storageTypes } = this.props
    return (
      values.map((row, idx) => {
        return (
        <TableRow key={idx}>
          <TableCell key={TYPE + idx}>
            <Dropdown value={row[TYPE]} source={storageTypes} onChange={this.handleChange.bind(this, idx, TYPE)}/>
          </TableCell>    
          <TableCell key={COUNT + idx}>
            <Input type='number' value={row[COUNT]} onChange={this.handleChange.bind(this, idx, COUNT)}/>
          </TableCell>
          <TableCell key={DETAILS + idx}>
            <Input type='text' value={row[DETAILS]} onChange={this.handleChange.bind(this, idx, DETAILS)}/>
          </TableCell>      
          <TableCell 
            styleName="deleteBtn"
            theme={styles}
            key={"delete" + idx}
          >
            <IconButton icon='delete' onClick={this.handleRemove(idx)} primary />
          </TableCell>
        </TableRow>
      )})
    )
  }

  render() {
    const tableHeadContent = {
      [TYPE]: (<TableCell key={2}>Type</TableCell>),
      [COUNT]: (<TableCell key={0}>Count</TableCell>),
      [DETAILS]: (<TableCell key={1}>Details</TableCell>),
    }

    return (
      <Fragment >
      <Table 
        selectable={false}
      >
        {this.getTableHead(tableHeadContent)}
        {this.renderRows()}
      </Table>
      <Button
        icon='add'
        label='Add Storage'
        flat
        primary
        onClick={ this.props.onAdd }
        styleName="universeAddBtn"
        theme={styles}
      />
    </Fragment>
    )
  }
}

export default CSSModules(ProductStorage, styles)
